export const PAGE_TITLE = 'Vela - Optimize your ecommerce business like never before';

export const PAGE_DESCRIPTION = 'Manage, optimize, and grow all your shops, across multiple ecommerce channels, though a single Vela account';

export const DIRECTION = {
  UP: 'up',
  DOWN: 'down',
};
